import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const IconWrap = styled.div`
  flex-shrink: 0;

  svg {
    width: 32px;
    height: 32px;
  }
`;
